module.exports = __webpack_public_path__ + "static/media/fl_cast_ynikolaev.34b24682.jpg";